//引入vue
import Vue from 'vue';

import store from './store'

//引入app组件，他是所有组件的父组件
import {Loading,Message,Drawer,DatePicker,TimeSelect,Popover,Button,Row,Col,Alert,MessageBox,Dialog,Collapse,CollapseItem,Tooltip,Input} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import App from './App.vue';
import './plugins/utils';
import 'element-ui/lib/theme-chalk/display.css';
//引入路由
import router from '@/router'
import axios from '@/api/request'
import Header from './components/Header/Header';
import Cart from './components/Cart/Cart';
import Login from './components/Login/Login';
import Footer from './components/Footer/Footer';
// import BaiduMap from 'vue-baidu-map';
import * as VueGoogleMaps from 'vue2-google-maps';

import VueAwesomeSwiper from 'vue-awesome-swiper';

import * as braze from "@braze/web-sdk";
// or, using `require`
// const braze = require("@braze/web-sdk");

// console.log("braze",process.env.VUE_APP_BRAZE_KEY)
braze.initialize(process.env.VUE_APP_BRAZE_KEY, {
  baseUrl: "sdk.iad-05.braze.com"
});
//测试
// braze.initialize('2fb4d8e0-c94e-46db-8c5b-4070afbe6ee5', {
//   baseUrl: "sdk.iad-05.braze.com"
// });
//正式
// braze.initialize('ccb5f6bd-f719-471c-a80c-2512862102ff', {
//   baseUrl: "sdk.iad-05.braze.com"
// });
// 2fb4d8e0-c94e-46db-8c5b-4070afbe6ee5
// sdk.iad-05.braze.com
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 
//   ak: 'YOUR_APP_KEY'
// })



Vue.use(VueGoogleMaps,{
  load:{
    key:"AIzaSyBaH4s92DNCk2dY2VN8GojQrMbwPZfXMR0",
    language:"en"
  }
})
// Vue.component('infoWindow', VueGoogleMaps.InfoWindow);
// Vue.prototype.$http=axios;
locale.use(lang)
Vue.use(Loading);
Vue.use(Drawer);
Vue.use(Popover);
Vue.use(TimeSelect);
Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(Tooltip);
Vue.use(Input);
Vue.prototype.braze=braze;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$message = Message

Vue.component("Header", Header)
Vue.component("Cart", Cart)
Vue.component("Login", Login)
Vue.component("Footer", Footer)
//关闭vue的生产提示
Vue.config.productionTip = false




// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional



Number.prototype.toFixed = function (n) {
 
  if (n > 20 || n < 0) {
      throw new RangeError('toFixed() digits argument must be between 0 and 20');
  }
  const number = this;
  if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString();
  }

  if (typeof (n) == 'undefined' || n == 0) {
      return (Math.round(number)).toString();
  }
  let result = number.toString();
  const arr = result.split('.');
  // 整数的情况
  if (arr.length < 2) {
      result += '.';
      for (let i = 0; i < n; i += 1) {
          result += '0';
      }
      return result;
  }
  const integer = arr[0];
  const decimal = arr[1];
  if (decimal.length == n) {
      return result;
  }

  if (decimal.length < n) {
      for (let i = 0; i < n - decimal.length; i += 1) {
          result += '0';
      }
      return result;
  }
  result = integer + '.' + decimal.substr(0, n);
  const last = decimal.substr(n, 1);
  // 四舍五入，转换为整数再处理，避免浮点数精度的损失
  if (parseInt(last, 10) >= 5) {
      const x = Math.pow(10, n);
      result = (Math.round((parseFloat(result) * x)) + 1) / x;
      result = result.toFixed(n);
  }
  return result;
}




export const eventBus = new Vue();

// import firebase from './plugins/firebase.js';
// console.log(123,process.env.VUE_APP_SOURCE_URL)
//创建vue实例对象---vm
const vm = new Vue({
  router, 
  store,
  data() {
    return {
      globalData: {
        url:process.env.VUE_APP_SOURCE_URL
        // url: "https://live.prodapp.baskinrobbins.my/"  //正式
        // url: "https://staging.devapp.baskinrobbins.my/" //测试
      },
      
    };
  },
  created(){
    this.braze.logCustomEvent("Last Open App", {
      Timestamp: new Date()
    });
    this.braze.requestPushPermission();
    this.braze.automaticallyShowInAppMessages();
  },
  render: h => h(App),
});
Vue.use(axios, vm);
vm.$mount('#app');
// console.log(444,process.env.VUE_APP_BASE_API)

